import { render } from "./Step2Component.vue?vue&type=template&id=56347364&scoped=true"
import script from "./Step2Component.vue?vue&type=script&lang=js"
export * from "./Step2Component.vue?vue&type=script&lang=js"

import "./Step2Component.vue?vue&type=style&index=0&id=56347364&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56347364"]])

export default __exports__